import React from 'react';

export default class NrgPage extends React.Component {

  _canPopupNavigateLeft() {
    return this.popupStore.canNavigateLeft() === true;
  }

  _canPopupNavigateRight() {
    return this.popupStore.canNavigateRight() === true;
  }

  _onPopupOpen() {
    this.setState({
      popupOpen: true
    });
  }

  _onPopupPopulate() {
    this.setState({
      popupPeople: this.popupStore.getCurrentPeople()
    });
  }

  _onPopupUpdatePerson() {
    this.setState({
      popupPerson: this.popupStore.getCurrentPerson()
    });
  }

  _onPopupClose() {
    this.setState({
      popupOpen: false
    });
  }

  _onOpenNews() {
    this.setState({
      newsOpen: true
    });
  }

  _onCloseNews() {
    this.setState({
      newsOpen: false
    });
  }
};
